import React from 'react';

// INTERFACES
import { IRow } from '../../interfaces/Grid.interface';

// STYLES
import { RowStyled } from './styles';

const Row: React.FC<IRow> = ({ children, centralized }: IRow) => {
  return <RowStyled centralized={centralized}>{children}</RowStyled>;
};

export default Row;
